const Portfolio = ({ inputData,
    colorTheme,
    pageData,
    headlineStart,
    headlineEnd }) => {
    return `<!DOCTYPE html>
        <html lang="en">
            <head>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content="${inputData.subheading}" />
                <link rel="icon" type="image/png" sizes="32x32" href="./favicon-32x32.png">
                <link rel="icon" type="image/png" sizes="16x16" href="./favicon-16x16.png">
                <link rel="apple-touch-icon" sizes="180x180" href="./apple-touch-icon.png">
                <link rel="icon" type="image/png" sizes="512x512" href="./android-chrome-512x512.png">
                <link rel="icon" type="image/png" sizes="192x192" href="./android-chrome-192x192.png">
                <link rel="manifest" href="./site.webmanifest">
                <title>${inputData.main_headline}</title>
                <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;800&display=swap" rel="stylesheet">
                <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    body {
                        font-family: 'Inter', sans-serif;
                        background: #060b1a;
                        color: #ffffff;
                        line-height: 1.6;
                    }
                    .container {
                        width: 90%;
                        max-width: 1200px;
                        margin: auto;
                    }
                    nav {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 30px 0;
                    }
                    .logo {
                        font-size: 22px;
                        font-weight: 800;
                    }
                    .nav-links {
                        display: flex;
                        gap: 40px;
                        list-style: none;
                    }
                    .nav-links a {
                        text-decoration: none;
                        color: #cfd3ff;
                        font-weight: 500;
                        transition: 0.3s;
                    }
                    .nav-links a:hover {
                        color: #ffffff;
                    }
                    .btn-primary {
                        padding: 12px 22px;
                        border-radius: 30px;
                        border: none;
                        font-weight: 600;
                        cursor: pointer;
                        background: white;
                        color: #060b1a;
                        transition: 0.3s;
                    }
                    .btn-primary:hover {
                        transform: translateY(-2px);
                    }
                    .hero {
                        padding: 80px 0 120px 0;
                    }
                    .hero-sub {
                        color: #7f8cff;
                        letter-spacing: 2px;
                        font-size: 14px;
                        margin-bottom: 30px;
                    }
                    .hero h1 {
                        font-size: 80px;
                        font-weight: 800;
                        line-height: 1.1;
                    }
                    .gradient-text {
                        background: linear-gradient(90deg, #ff6a8b, #a64cff);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                    .hero p {
                        margin-top: 30px;
                        max-width: 600px;
                        color: #aab0d6;
                        font-size: 20px;
                    }
                    .hero-buttons {
                        margin-top: 40px;
                        display: flex;
                        gap: 20px;
                    }
                    .btn-outline {
                        padding: 16px 30px;
                        border-radius: 40px;
                        border: none;
                        font-weight: 600;
                        cursor: pointer;
                        background: #ffffff;
                        color: #060b1a;
                    }
                    .btn-secondary {
                        padding: 16px 30px;
                        border-radius: 40px;
                        border: none;
                        font-weight: 600;
                        background: #1b213b;
                        color: white;
                    }
                    .stats {
                        padding: 80px 0;
                        border-top: 1px solid #111737;
                        border-bottom: 1px solid #111737;
                    }
                    .stats-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                        gap: 40px;
                        text-align: center;
                    }
                    .stat h2 {
                        font-size: 60px;
                        background: linear-gradient(90deg, #ff6a8b, #a64cff);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                    .stat p {
                        color: #9aa3d8;
                    }
                    .projects {
                        padding: 100px 0;
                    }
                    .section-label {
                        color: #7f8cff;
                        letter-spacing: 2px;
                        font-size: 14px;
                        margin-bottom: 20px;
                    }
                    .projects-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 20px;
                    }
                    .projects h2 {
                        font-size: 50px;
                    }
                    .filters {
                        display: flex;
                        gap: 10px;
                    }

.filter-btn {
  padding: 10px 20px;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  background: #1b213b;
  color: #fff;
  transition: 0.3s;
}

.filter-btn.active {
  background: #ffffff;
  color: #060b1a;
}

.projects-grid {
  margin-top: 60px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.project-card {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  cursor: pointer;
}

.project-card img {
  width: 100%;
  height: 350px;
  object-fit: cover;
  transition: 0.4s;
}

.project-card:hover img {
  transform: scale(1.05);
}

.project-overlay {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 30px;
  background: linear-gradient(transparent, rgba(0,0,0,0.8));
}

.project-overlay h3 {
  font-size: 26px;
}

.tags {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.tag {
  background: rgba(255,255,255,0.2);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
}

/* RESPONSIVE */
@media(max-width:768px){
  .hero h1 {
    font-size: 50px;
  }
  .projects h2 {
    font-size: 36px;
  }
}

/* ABOUT SECTION */
.about {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*padding: 80px 0;*/
  padding: 80px 0 120px 0;

}

.about-text {
  flex: 1;
  max-width: 600px;
  padding-left: 22px;
}

.about-text h2 {
  font-size: 48px;
  margin-bottom: 20px;
}

.about-text p {
  font-size: 18px;
  color: #aab0d6;
}

.about-social {
  flex: 1;
  display: flex;
  justify-content: center;
}

.about-social img {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  padding: 8px;
}

/* GET IN TOUCH SECTION */
.contact {
  padding: 80px 0;
  background-color: #1b213b;
}

.contact-header {
  text-align: center;
  margin-bottom: 40px;
}

.contact-header h2 {
  font-size: 50px;
  color: #ffffff;
}

.contact-form {
  display: flex;
  justify-content: center;
}

.contact-form form {
  background-color: #060b1a;
  padding: 40px;
  border-radius: 10px;
  width: 60%;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 15px;
  margin-bottom: 20px;
  border: none;
  border-radius: 8px;
  background-color: #2c3548;
  color: #ffffff;
  font-size: 16px;
}

.contact-form button {
  padding: 15px 30px;
  border-radius: 30px;
  border: none;
  background-color: #ff6a8b;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.contact-form button:hover {
  background-color: #a64cff;
}

/* RESPONSIVE */
@media(max-width:768px){
  .about {
    flex-direction: column;
    text-align: center;
  }

  .about-text h2 {
    font-size: 36px;
  }

  .contact-form {
    width: 90%;
  }
}
</style>
</head>
<body>

<div class="container">
  <nav>
    <div class="logo">${inputData.brand_name}</div>
    <ul class="nav-links">
    ${inputData.sections.split(",").map(section => section.trim()).map((s, index) =>
        `<li key=${index}><a>${s}<a/></li>`
    )}
    </ul>
  </nav>

  <section class="hero">
    <div class="hero-sub">${inputData.tag}</div>
    <h1>
      ${headlineStart} <br>
      <span class="gradient-text">${headlineEnd}</span>
    </h1>
    <p>${inputData.subheading}</p>
    <div class="hero-buttons">
      <button class="btn-outline">${inputData.primary_button_text}</button>
      <button class="btn-secondary">${inputData.secondary_button_text}</button>
    </div>
  </section>
</div>

<section class="stats">
  <div class="container">
    <div class="stats-grid">
      <div class="stat">
        <h2>150+</h2>
        <p>Projects Delivered</p>
      </div>
      <div class="stat">
        <h2>50+</h2>
        <p>Happy Clients</p>
      </div>
      <div class="stat">
        <h2>12</h2>
        <p>Years Experience</p>
      </div>
      <div class="stat">
        <h2>25</h2>
        <p>Awards Won</p>
      </div>
    </div>
  </div>
</section>

<section class="projects">
  <div class="container">
        <div class="projects-header">
      <h2>Featured Projects</h2>
      <div class="filters">
        <button class="filter-btn active" data-filter="all">All</button>
        <button class="filter-btn" data-filter="branding">Branding</button>
        <button class="filter-btn" data-filter="web">Web</button>
        <button class="filter-btn" data-filter="app">App</button>
      </div>
    </div>

    <div class="projects-grid">
      <div class="project-card" data-category="web">
        <img src="https://images.unsplash.com/photo-1509042239860-f550ce710b93" alt="Artisan Coffee">
        <div class="project-overlay">
          <div class="tags">
            <span class="tag">E-commerce</span>
            <span class="tag">Development</span>
          </div>
          <h3>Artisan Coffee</h3>
        </div>
      </div>

      <div class="project-card" data-category="app">
        <img src="https://picsum.photos/800/400" alt="TechFlow SaaS">
        <div class="project-overlay">
          <div class="tags">
            <span class="tag">SaaS</span>
            <span class="tag">Dashboard</span>
          </div>
          <h3>TechFlow SaaS</h3>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- ABOUT SECTION -->
<section class="about">
  <div class="about-text">
    <h2>We believe in the power of design</h2>
    <p>
      For over a decade, we've been helping brands tell their stories through thoughtful design and innovative digital experiences. Our multidisciplinary team combines strategy, creativity, and technology to deliver results that matter.
    </p>
    <p>
      We're not just designers — we're partners in your success. Every project is an opportunity to push boundaries and create something truly remarkable.
    </p>
    <div>
      <!-- Social Links -->
      <a href="#" style="color: #cfd3ff; margin-right: 20px;">Instagram</a>
      <a href="#" style="color: #cfd3ff; margin-right: 20px;">Twitter</a>
      <a href="#" style="color: #cfd3ff;">LinkedIn</a>
    </div>
  </div>

  <div class="about-social">
    <img src="https://picsum.photos/800/400" alt="Team Image">
  </div>
</section>

<!-- GET IN TOUCH SECTION -->
<section class="contact">
  <div class="container">
    <div class="contact-header">
      <h2>Let's create something amazing together</h2>
    </div>

    <div class="contact-form">
      <form action="#" method="POST">
        <input type="text" name="name" placeholder="Name" required />
        <input type="email" name="email" placeholder="Email" required />
        <input type="text" name="subject" placeholder="Subject" required />
        <textarea name="message" placeholder="Tell us about your project..." rows="6" required></textarea>
        <button type="submit">Send Message</button>
      </form>
    </div>
  </div>
</section>

<script>
// If you want to add any JS functionality later, you can add it here
</script>

</body>
</html>`
}

export default Portfolio;